// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconDelivery = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M4.78 6l.4-2h11.138l1.875 5H23v9h-3a2 2 0 11-4 0h-6a2 2 0 11-4 0H4v-2h17v-5h-8.5V9h3.557l-1.125-3z" />,
    <path d="M0 10h8V8H0zm6 4H0v-2h6z" />
  );
export default SvgIconDelivery;
